import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/tick.svg';
import { mapGetters } from 'vuex';
import { validateEmail } from '~/helpers/validation-helper';
import isNewProduct from '~/const/patch/newProducts';
import optinProductAvailabilityMutation from '@/graphql/mutation/optinProductAvailability.gql';
export default {
  name: 'TheEmailForm',
  props: {
    locale: {
      type: Object,
      required: true
    },
    reference: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      userEmail: '',
      hasError: false,
      isComplete: false,
      needsChecking: false,
      alertFormMessage: '',
      xhrUri: ''
    };
  },

  computed: _objectSpread({}, mapGetters({
    sharedEnv: 'sharedEnv/getSharedEnv'
  }), {
    comingSoonLabel() {
      return isNewProduct(this.reference) ? 'new_product_stock' : 'product_stock';
    }

  }),
  methods: {
    handleBlur(event) {
      if (event.target.value === '') {
        this.hasError = false;
      }

      if (!this.isComplete && event.target.value !== '') {
        this.needsChecking = true;
        this.checkEmail();
      }
    },

    checkIfComplete() {
      this.isComplete = validateEmail(this.userEmail);
    },

    checkEmail() {
      this.hasError = !validateEmail(this.userEmail);
      this.isComplete = !this.hasError;
      return this.isComplete ? validateEmail(this.userEmail) : null;
    },

    createAlertDispo() {
      // Quick sanitize before posting email value
      if (!validateEmail(this.userEmail)) {
        return;
      }

      this.$apolloProvider.defaultClient.mutate({
        mutation: optinProductAvailabilityMutation,
        variables: {
          locale: this.locale.iso,
          reference: this.reference,
          email: this.userEmail
        }
      }).then((_ref) => {
        let {
          data: {
            optinProductAvailability: isSuccess
          }
        } = _ref;
        this.alertFormMessage = isSuccess ? 'product_form_confirm' : 'product_form_error';
      });
    }

  }
};